import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PreferencesService {
  private listDisplay = new BehaviorSubject<boolean>(JSON.parse(localStorage.getItem("listDisplay")));

  constructor() { }
  listDisplay$ = this.listDisplay.asObservable();

  updateCardDisplay(listDisplay: boolean) {
    this.listDisplay.next(listDisplay);
    localStorage.setItem("listDisplay", JSON.stringify(listDisplay));
  }
}
